// import React, { useState } from "react";
// import { Typography, Popover, Box } from "@mui/material";
// import { formatValue } from "./utils";
// import translations from './translations';

// export const ObjectPopover = ({ value }) => {
//   const [anchorEl, setAnchorEl] = useState(null);

//   const translateValue = (val) => {
//     if (typeof val === 'object') {
//       if (Array.isArray(val)) {
//         return val.map(item => translateValue(item)).join(', ');
//       }
      
//       return Object.entries(val)
//         .map(([key, value]) => {
//           const translatedKey = translations[key] || key;
//           const translatedValue = translateValue(value);
//           return `${translatedKey}: ${translatedValue}`;
//         })
//         .join(', ');
//     }
    
//     return translations[val] || formatValue(val);
//   };

//   const displayValue = translateValue(value);

//   return (
//     <>
//       <Typography
//       >
//         {displayValue}
//       </Typography>
//       <Popover
//         open={Boolean(anchorEl)}
//         anchorEl={anchorEl}
//         onClose={() => setAnchorEl(null)}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "left",
//         }}
//         transformOrigin={{
//           vertical: "top",
//           horizontal: "left",
//         }}
//       >
//         <Box sx={{ p: 2, maxWidth: 300 }}>
//           <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
//             {JSON.stringify(
//               Object.fromEntries(
//                 Object.entries(value).map(([key, val]) => [
//                   translations[key] || key,
//                   translateValue(val)
//                 ])
//               ),
//               null,
//               2
//             )}
//           </pre>
//         </Box>
//       </Popover>
//     </>
//   );
// };
import React, { useState } from "react";
import { Typography, Popover, Box } from "@mui/material";
import { formatValue } from "./utils";
import translations from './translations';

export const ObjectPopover = ({ value }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const translateValue = (val) => {
    // בדיקת ערכים ריקים
    if (val === null || val === undefined) {
      return '-';
    }

    if (typeof val === 'object') {
      // בדיקה שהערך הוא אובייקט תקין
      if (!val) {
        return '-';
      }

      if (Array.isArray(val)) {
        return val.map(item => translateValue(item)).join(', ') || '-';
      }
      
      const entries = Object.entries(val).filter(([_, v]) => v !== null && v !== undefined);
      if (entries.length === 0) {
        return '-';
      }

      return entries
        .map(([key, value]) => {
          const translatedKey = translations[key] || key;
          const translatedValue = translateValue(value);
          return `${translatedKey}: ${translatedValue}`;
        })
        .join(', ');
    }
    
    return translations[val] || formatValue(val);
  };

  // בדיקה שיש ערך תקין
  if (!value || typeof value !== 'object') {
    return <Typography>-</Typography>;
  }

  const displayValue = translateValue(value);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Typography
        onClick={handleClick}
        sx={{ 
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline'
          }
        }}
      >
        {displayValue}
      </Typography>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 300 }}>
          <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
            {JSON.stringify(
              Object.fromEntries(
                Object.entries(value || {})
                  .filter(([_, v]) => v !== null && v !== undefined)
                  .map(([key, val]) => [
                    translations[key] || key,
                    translateValue(val)
                  ])
              ),
              null,
              2
            )}
          </pre>
        </Box>
      </Popover>
    </>
  );
};

export default ObjectPopover;